import { State } from './../_models/state';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Courier } from "../_models/courier.js";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StateService {
  constructor(private http: HttpClient, public auth: AuthService) {}

  public getStates() {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.states}/`;
    return this.http.get<State[]>(requestUrl, options);
  }
  
  public getState(stateId: number) {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.states}/${stateId}`;
    return this.http.get<State>(requestUrl, options);
  }

  public addState(state: State): Observable<State> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.states}/`;
    console.log(requestUrl);
    return this.http.post<State>(requestUrl, state, options);
  }

  public updateState(state: State): Observable<State> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.states}/${state.id}`;
    console.log(requestUrl);
    return this.http.put<State>(requestUrl, state, options);
  }

  public deleteState(stateId: number) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.states}/${stateId}`;
    console.log(requestUrl);
    return this.http.delete(requestUrl, options);
  }
}
